import React from 'react';
import { fx } from '../../fx.js';
import { DISPLAY } from '../../primitives.js';

const h = React.createElement;

/**
 * Page title in Syne 800. Never below 26px, never in a card.
 *
 * @param {object} p
 * @param {boolean|'session'} [p.drop]
 * @param {React.ReactNode} [p.children]
 * @param {number} [p.size]
 * @param {React.CSSProperties} [p.style]
 */
export function H1({ children, size = 34, style, drop }) {
  const text = typeof children === 'string' ? children : null;
  const [play] = React.useState(() => { const f = fx; if (!drop || !text || (f.reduced && f.reduced())) return false; return drop === 'session' ? f.once('h1:' + text) : true; });
  const [seed] = React.useState(() => Math.random());
  const S = { margin: 0, fontFamily: DISPLAY, fontWeight: 800, fontSize: size, lineHeight: 1.05, letterSpacing: 'var(--track-display)', color: 'var(--tx)', textWrap: 'balance', ...style };
  if (!drop || !text) return h('h1', { style: S }, children);
  let i = 0;
  const words = text.split(' ');
  return h('h1', { style: S, 'aria-label': text },
    words.map((w, wi) => h(React.Fragment, { key: wi },
      h('span', { className: 'gx-word', 'aria-hidden': true }, Array.from(w).map((ch) => { const k = i++; const r = (((Math.sin((k + 1) * 12.9898 + seed * 78.233) * 43758.5453) % 1) * 16 - 8).toFixed(1); return h('span', { key: k, className: 'gx-letter' + (play ? ' gx-in' : ''), style: { '--i': k, '--r': r + 'deg' } }, ch); })),
      wi < words.length - 1 ? ' ' : null)));
}
